export default __webpack_public_path__ + "static/media/Liability.48920140.svg";